export const POST_SCHEDULE = 'POST_SCHEDULE';
export const LIST_SCHEDULE = 'LIST_SCHEDULE';
